import {
	Card,
	CardActionArea,
	CardContent,
	CardHeader,
	Grid,
	Typography
} from '@mui/material';
import React, { useCallback } from 'react';
import { OAuthProviders } from 'types/auth';

interface ISocialCardProps {
	logo: string;
	socialName: OAuthProviders;
	clientId?: string;
	onClick: (socialName: OAuthProviders) => void;
}

const SocialCard: React.FC<ISocialCardProps> = ({
	logo,
	socialName,
	clientId,
	onClick
}) => {
	const onClickCallback = useCallback(() => {
		onClick(socialName);
	}, [onClick, socialName]);

	const cardContentId = clientId
		? 'authMethods.social.card.myOwn'
		: `authMethods.social.card.${socialName}`;

	return (
		<Grid item xs={6} pr={2}>
			<CardActionArea
				onClick={onClickCallback}
				data-testid="social-card"
				sx={{ display: 'flex' }}
			>
				<Card sx={{ height: 135, boxShadow: 4, flex: 1 }}>
					<CardHeader
						avatar={
							<img
								src={logo}
								alt={intl.tr(cardContentId)}
								width={100}
								height={40}
							/>
						}
					/>
					<CardContent>
						<Typography variant="body2" color="textSecondary">
							{intl.tr(cardContentId)}
						</Typography>
					</CardContent>
				</Card>
			</CardActionArea>
		</Grid>
	);
};

SocialCard.defaultProps = {
	clientId: undefined
};
export default SocialCard;
